module.exports = __webpack_public_path__ + "static/img/case_banner_16.58f9b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_16.png
// module id = sn8g
// module chunks = 34